import React, { useEffect,  } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ScreenHeader } from "react-library";
import { Routes } from "../../routes";
import "./pest-sensors.css";
import { CropStageDetails } from "../cropStageDetails";
import PestSpeedoMeters from "./component/PestSpeedoMeters";
import { t } from "../../services/locale.service";

const PestSensorsScreen: React.FC = () => {
  const { plotId } = useParams();
  const navigate = useNavigate();


  const headerTitle = t("pest_sensors");

  const viewCropStageDetails = (e: Event) => {
    const event = e as Event & { detail: CropStageDetails };
    navigate(Routes.cropStageDetails.replace(":plotId", plotId!), { state: { cropStageDetails: event.detail } });
  };

  const handleBack = () => {
    try {
      window.history.back();
    } catch (error) {
      console.log(error);      
    }
  };

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    window.addEventListener(
      "open-cropstage-details",
      viewCropStageDetails
    );
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
      window.removeEventListener("open-cropstage-details", viewCropStageDetails);
    };
  }, []);

  return (
    <div className="container">
      <ScreenHeader screenName={headerTitle} />
      <PestSpeedoMeters plotId={plotId!} /> 

      {/* {hasInsights && (
          <SpeedoMetersContainer
            plotId={plotId!}
            farmData={farmData}
            speedoMeterFor="insight"
          />
        )} */}
    </div>
  );
};

export default PestSensorsScreen;
 
 
export const Insights = ["deltaT", "VPD"];
